module.exports = __webpack_public_path__ + "static/media/1019689.3b4d5dcd.jpg";